export default __webpack_public_path__ + "static/media/web.7eb5a4d7.cdz";